document.addEventListener('DOMContentLoaded', function() {
  // Formular auf der Produktseite suchen
  const form = document.querySelector('form[action="/cart/add"]');

  // Toast-Meldung erstellen
  const toast = document.createElement('div');
  toast.id = 'cart-toast';
  toast.style.cssText = "display:none;position:fixed;bottom:20px;right:20px;background:#4caf50;color:white;padding:10px 20px;border-radius:5px;z-index:9999;";
  toast.textContent = 'Produkt erfolgreich hinzugefügt!';
  document.body.appendChild(toast);

  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault(); // verhindert Seitenwechsel

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method:'POST',
        body: formData,
        headers: {'Accept':'application/json'}
      })
      .then(res => res.json())
      .then(data => {
        toast.style.display = 'block';
        setTimeout(() => toast.style.display = 'none', 2000);
      })
      .catch(() => alert('Fehler beim Hinzufügen'));
    });
  }
});
document.addEventListener('DOMContentLoaded', function() {
  const button = document.getElementById('custom-add-to-cart-2310');

  const toast = document.createElement('div');
  toast.id = 'cart-toast';
  toast.style.cssText = "display:none;position:fixed;bottom:20px;right:20px;background:#4caf50;color:white;padding:10px 20px;border-radius:5px;z-index:9999;";
  toast.textContent = 'Produkt erfolgreich hinzugefügt!';
  document.body.appendChild(toast);

  if(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();        // verhindert Seitenwechsel
      e.stopPropagation();       // verhindert, dass Theme-Script den Klick verarbeitet

      const form = button.closest('form');
      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method:'POST',
        body: formData,
        headers: {'Accept':'application/json'}
      })
      .then(res => res.json())
      .then(data => {
        toast.style.display = 'block';
        setTimeout(() => toast.style.display = 'none', 2000);
        console.log('Produkt hinzugefügt:', data);
      })
      .catch(() => alert('Fehler beim Hinzufügen'));
    });
  }
});
